import { render } from "./AIAct.vue?vue&type=template&id=73635cc4&scoped=true"
import script from "./AIAct.vue?vue&type=script&lang=js"
export * from "./AIAct.vue?vue&type=script&lang=js"

import "./AIAct.vue?vue&type=style&index=0&id=73635cc4&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73635cc4"]])

export default __exports__